import { Selector } from "@ngxs/store";

import { ExceptionState, ExceptionStateModel } from "./exception.state";
import { Exception } from "../../core/models";
import { IRequestsNestedState } from "../interfaces/requests.interface";

export class ExceptionGetterState {
  @Selector([ExceptionState])
  static getExceptionState(state: ExceptionStateModel): ExceptionStateModel {
    return state;
  }

  @Selector([ExceptionState])
  static getExceptions(state: ExceptionStateModel): Exception<any>[] {
    return state.ids.map((id) => state.entities[id]);
  }

  @Selector([ExceptionState])
  static getExceptionGetRequestState(
    state: ExceptionStateModel
  ): IRequestsNestedState {
    return state.exceptionGetRequestState;
  }

  @Selector([ExceptionState])
  static getSaveExceptionPostRequestState(
    state: ExceptionStateModel
  ): IRequestsNestedState {
    return state.saveExceptionPostRequestState;
  }

  @Selector([ExceptionState])
  static getDeleteExceptionPostRequestState(
    state: ExceptionStateModel
  ): IRequestsNestedState {
    return state.deleteExceptionPostRequestState;
  }
}
